import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Briefcase, UserPlus } from "lucide-react";
import { useTranslation } from "../i18n/useTranslation";

const Footer = ({ theme = "white" }) => {
  const { t } = useTranslation();
  return (
    <div className={`footer footer-${theme} pt-10 bg-white`}>
      <div className="container pb-16">
        <div className="max-w-6xl mx-auto md:flex md:justify-between md:items-start gap-x-8 px-4 md:px-8">
          <div className="flex-1 md:max-w-sm">
          <Link to="/">
            <img
              className="h-10"
              src={require("../assets/img/Stabilize-Ai2.png")}
              alt="Logo"
            />
          </Link>

          <div className="text-sm text-gray-500 py-6">
            {t("footerCompanyDesc")}
          </div>
        </div>

        <div className="flex flex-col gap-6 md:flex-shrink-0 md:ml-auto md:max-w-sm">
          <div className="flex gap-3">
            <MapPin className="w-4 h-4 text-gray-500 flex-shrink-0 mt-0.5" />
            <div>
              <div className="text-sm font-medium text-[#3d3d3d] mb-2">{t("footerAddressTitle")}</div>
              <div className="text-sm text-gray-500 leading-relaxed">{t("footerAddress")}</div>
            </div>
          </div>
          <div className="flex gap-3">
            <Briefcase className="w-4 h-4 text-gray-500 flex-shrink-0 mt-0.5" />
            <div>
              <div className="text-sm font-medium text-[#3d3d3d] mb-2">{t("footerBusinessDesc")}</div>
              <a href="mailto:business@stabilize-ai.com" className="text-sm text-[#00B9D2] hover:underline">{t("footerBusinessEmail")}</a>
            </div>
          </div>
          <div className="flex gap-3">
            <UserPlus className="w-4 h-4 text-gray-500 flex-shrink-0 mt-0.5" />
            <div>
              <div className="text-sm font-medium text-[#3d3d3d] mb-2">{t("footerJoinTitle")}</div>
              <a href="mailto:hr@stabilize-ai.com" className="text-sm text-[#00B9D2] hover:underline">{t("footerJoinEmail")}</a>
            </div>
          </div>
        </div>
        </div>
      </div>

      <div className="border-t border-gray-200 py-8">
        <p className="text-xs text-[#00B9D2] text-center">
          {t("copyright")}
        </p>
      </div>
    </div>
  );
};

export default Footer;
